import React from 'react';
import SEO from '../components/seo/SEO';
import ProductCategories from '../components/home/ProductCategories';
import Advantages from '../components/home/Advantages';
import FeaturedProjects from '../components/home/FeaturedProjects';
import Testimonials from '../components/home/Testimonials';
import Faq from '../components/home/Faq';
import CallToAction from '../components/home/CallToAction';

const HomePage: React.FC = () => {
  return (
    <>
      <SEO 
        title="Трансформаторы ТСЛ и ТСЗ от Проминнова - экономия до 10%"
        description="Проминнова - поставщик трансформаторов ТСЛ и ТСЗ, КТПН, КСО и кабеля. Экономия до 10%, производство за 50-75 дней, доставка по РФ и СНГ. Гарантия 36 месяцев."
        keywords="трансформаторы ТСЛ, трансформаторы ТСЗ, купить трансформатор, КТПН цена, КСО, силовой кабель, Проминнова"
      />
      
      {/* Hero section - full width */}
      {/* <Hero /> */}

      {/* Main content - within container */}
      <main className="container mx-auto px-4 py-8">
        <ProductCategories />
        <Advantages />
        <FeaturedProjects />
        <Testimonials />
        <Faq />
        <CallToAction />
      </main>
    </>
  );
};

export default HomePage;